'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode, TextareaHTMLAttributes } from 'react';
import type { FieldShellRenderArgs, FieldShellSize } from '@/components/ui/field-shell';
import { FieldShell } from '@/components/ui/field-shell';
import { Textarea } from '@/components/ui/textarea';
import { cn } from '@/lib/ui/utils';
interface TextareaFieldOwnProps {
  label?: ReactNode;
  description?: string | undefined;
  error?: string | undefined;
  size?: FieldShellSize | undefined;
  fullWidth?: boolean | undefined;
  containerClassName?: string | undefined;
  labelClassName?: string | undefined;
  descriptionClassName?: string | undefined;
  errorClassName?: string | undefined;
}
export type TextareaFieldProps = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'size'> & TextareaFieldOwnProps;
export function TextareaField(t0) {
  const $ = _c(33);
  let containerClassName;
  let description;
  let descriptionClassName;
  let disabled;
  let error;
  let errorClassName;
  let fullWidth;
  let id;
  let label;
  let labelClassName;
  let readOnly;
  let required;
  let size;
  let textareaProps;
  if ($[0] !== t0) {
    ({
      label,
      description,
      error,
      size,
      fullWidth,
      containerClassName,
      labelClassName,
      descriptionClassName,
      errorClassName,
      id,
      required,
      disabled,
      readOnly,
      ...textareaProps
    } = t0);
    $[0] = t0;
    $[1] = containerClassName;
    $[2] = description;
    $[3] = descriptionClassName;
    $[4] = disabled;
    $[5] = error;
    $[6] = errorClassName;
    $[7] = fullWidth;
    $[8] = id;
    $[9] = label;
    $[10] = labelClassName;
    $[11] = readOnly;
    $[12] = required;
    $[13] = size;
    $[14] = textareaProps;
  } else {
    containerClassName = $[1];
    description = $[2];
    descriptionClassName = $[3];
    disabled = $[4];
    error = $[5];
    errorClassName = $[6];
    fullWidth = $[7];
    id = $[8];
    label = $[9];
    labelClassName = $[10];
    readOnly = $[11];
    required = $[12];
    size = $[13];
    textareaProps = $[14];
  }
  const t1 = textareaProps["aria-describedby"];
  let t2;
  if ($[15] !== textareaProps) {
    t2 = t3 => {
      const {
        controlProps
      } = t3;
      return <Textarea {...textareaProps} {...controlProps} className={cn("rounded-control text-body-lg md:text-body", "border-solid bg-background-primary dark:bg-background-primary shadow-none", "transition-[color,background-color,border-color,box-shadow]", "placeholder:text-foreground-tertiary", "disabled:bg-background-secondary dark:disabled:bg-background-secondary", "hover:border-border-brand focus:border-border-brand focus-visible:border-border-brand active:border-border-brand", "aria-invalid:ring-0", "aria-invalid:focus-visible:ring-[3px] aria-invalid:focus-visible:ring-feedback-error-border/30 dark:aria-invalid:focus-visible:ring-feedback-error-border/40", "aria-invalid:hover:border-feedback-error-border aria-invalid:focus:border-feedback-error-border aria-invalid:active:border-feedback-error-border", textareaProps.className)} />;
    };
    $[15] = textareaProps;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  let t3;
  if ($[17] !== containerClassName || $[18] !== description || $[19] !== descriptionClassName || $[20] !== disabled || $[21] !== error || $[22] !== errorClassName || $[23] !== fullWidth || $[24] !== id || $[25] !== label || $[26] !== labelClassName || $[27] !== readOnly || $[28] !== required || $[29] !== size || $[30] !== t1 || $[31] !== t2) {
    t3 = <FieldShell label={label} description={description} error={error} size={size} fullWidth={fullWidth} required={required} disabled={disabled} readOnly={readOnly} id={id} ariaDescribedBy={t1} containerClassName={containerClassName} labelClassName={labelClassName} descriptionClassName={descriptionClassName} errorClassName={errorClassName}>{t2}</FieldShell>;
    $[17] = containerClassName;
    $[18] = description;
    $[19] = descriptionClassName;
    $[20] = disabled;
    $[21] = error;
    $[22] = errorClassName;
    $[23] = fullWidth;
    $[24] = id;
    $[25] = label;
    $[26] = labelClassName;
    $[27] = readOnly;
    $[28] = required;
    $[29] = size;
    $[30] = t1;
    $[31] = t2;
    $[32] = t3;
  } else {
    t3 = $[32];
  }
  return t3;
}